import { TriState } from "./Enums";

export class NotificationSearchParameters {
    pageNumber: number = 0;
    searchText: string = "";
    id: number = 0;
    userID: number = 0;
    isDeleted: TriState = TriState.UseDefault;
}